(function () {
  'use strict';

  var checkoutSelector = '.zd-drawer-checkout';
  var checkoutUrl = '/checkout';

  function convertCheckoutButton(element) {
    if (!element || !element.matches || !element.matches(checkoutSelector)) return;

    if (element.tagName === 'A') {
      element.setAttribute('href', checkoutUrl);
      element.setAttribute('data-zd-direct-checkout', 'true');
      element.removeAttribute('disabled');
      element.removeAttribute('aria-disabled');
      return;
    }

    var link = document.createElement('a');
    var blockedAttributes = ['type', 'form', 'name', 'disabled', 'aria-disabled'];

    Array.prototype.forEach.call(element.attributes, function (attribute) {
      if (blockedAttributes.indexOf(attribute.name) === -1) {
        link.setAttribute(attribute.name, attribute.value);
      }
    });

    link.setAttribute('href', checkoutUrl);
    link.setAttribute('role', 'button');
    link.setAttribute('data-zd-direct-checkout', 'true');
    link.innerHTML = element.innerHTML;
    element.replaceWith(link);
  }

  function upgradeCheckoutButtons(root) {
    var scope = root && root.querySelectorAll ? root : document;

    if (scope.matches && scope.matches(checkoutSelector)) {
      convertCheckoutButton(scope);
    }

    Array.prototype.forEach.call(scope.querySelectorAll(checkoutSelector), convertCheckoutButton);
  }

  function initialise() {
    upgradeCheckoutButtons(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes') {
          convertCheckoutButton(mutation.target);
          return;
        }

        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType === 1) upgradeCheckoutButtons(node);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled']
    });
  }

  document.addEventListener('click', function (event) {
    var checkout = event.target.closest && event.target.closest(checkoutSelector);
    if (!checkout) return;

    event.preventDefault();
    window.location.assign(checkoutUrl);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }

  window.addEventListener('pageshow', function () {
    upgradeCheckoutButtons(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    upgradeCheckoutButtons(event.target || document);
  });
})();

(function () {
  'use strict';

  var MOBILE_MAX = 1024;
  var LAUNCHER_SCALE = 0.81;
  var STYLE_ID = 'zenduce-richpanel-mobile-size-fix';
  var LAUNCHER_ATTR = 'data-zenduce-rp-launcher';
  var WINDOW_ATTR = 'data-zenduce-rp-window';

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX;
  }

  function ensureStyle() {
    var style = document.getElementById(STYLE_ID);
    var css = '' +
      '@media(max-width:' + MOBILE_MAX + 'px){' +
        '[' + LAUNCHER_ATTR + '=\"true\"]{' +
          'transform:scale(' + LAUNCHER_SCALE + ') !important;' +
          'transform-origin:bottom right !important;' +
          'transition:transform .16s ease !important;' +
          'z-index:2147483646 !important;' +
        '}' +
        '[' + WINDOW_ATTR + '=\"true\"]{' +
          'position:fixed !important;' +
          'inset:0 !important;' +
          'top:0 !important;right:0 !important;bottom:0 !important;left:0 !important;' +
          'width:100vw !important;max-width:100vw !important;min-width:100vw !important;' +
          'height:100dvh !important;max-height:100dvh !important;min-height:100dvh !important;' +
          'margin:0 !important;border-radius:0 !important;transform:none !important;' +
          'z-index:2147483647 !important;' +
        '}' +
      '}';

    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      document.head.appendChild(style);
    }

    if (style.textContent !== css) style.textContent = css;
  }

  function viewport() {
    return {
      width: window.innerWidth || document.documentElement.clientWidth || 0,
      height: window.innerHeight || document.documentElement.clientHeight || 0
    };
  }

  function signal(node) {
    if (!node || !node.getAttribute) return '';
    var out = [];
    ['id', 'class', 'src', 'title', 'aria-label', 'name', 'role'].forEach(function (attr) {
      var val = node.getAttribute(attr);
      if (val) out.push(String(val));
    });
    return out.join(' ').toLowerCase();
  }

  function hasRichpanelSignal(node) {
    var s = signal(node);
    return s.indexOf('richpanel') !== -1 ||
      s.indexOf('rich-panel') !== -1 ||
      s.indexOf('rp-') !== -1 ||
      s.indexOf('messenger') !== -1 ||
      s.indexOf('launcher') !== -1 ||
      s.indexOf('chat') !== -1 ||
      s.indexOf('support') !== -1;
  }

  function isExcluded(node) {
    var s = signal(node);
    return s.indexOf('shopify') !== -1 ||
      s.indexOf('swym') !== -1 ||
      s.indexOf('cart') !== -1 ||
      s.indexOf('wishlist') !== -1 ||
      s.indexOf('judge') !== -1 ||
      s.indexOf('loox') !== -1 ||
      s.indexOf('klaviyo') !== -1 ||
      s.indexOf('paypal') !== -1 ||
      s.indexOf('gpay') !== -1 ||
      s.indexOf('dynamic-checkout') !== -1;
  }

  function visible(node) {
    if (!node || !node.getBoundingClientRect) return false;
    var rect = node.getBoundingClientRect();
    var style = window.getComputedStyle(node);
    return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity || 1) !== 0;
  }

  function floating(node) {
    var pos = window.getComputedStyle(node).position;
    return pos === 'fixed' || pos === 'absolute';
  }

  function bottomRight(rect) {
    var vp = viewport();
    return rect.right >= vp.width - 180 && rect.bottom >= vp.height - 180;
  }

  function highLayer(node) {
    var z = parseInt(window.getComputedStyle(node).zIndex, 10) || 0;
    return z >= 50;
  }

  function isLauncher(node) {
    if (!isMobile() || !visible(node) || !floating(node) || isExcluded(node)) return false;

    var rect = node.getBoundingClientRect();
    var smallBubble = rect.width >= 35 && rect.height >= 35 && rect.width <= 210 && rect.height <= 210;
    var obviousIframe = node.tagName === 'IFRAME' && smallBubble && bottomRight(rect) && highLayer(node);

    return bottomRight(rect) && smallBubble && highLayer(node) && (hasRichpanelSignal(node) || obviousIframe);
  }

  function isChatWindow(node) {
    if (!isMobile() || !visible(node) || !floating(node) || isExcluded(node)) return false;

    var rect = node.getBoundingClientRect();
    var vp = viewport();
    var large = rect.width >= 240 || rect.height >= 320;
    var notLauncher = !(rect.width <= 210 && rect.height <= 210 && bottomRight(rect));
    var notFullscreen = rect.width < vp.width - 8 || rect.height < vp.height - 8 || rect.left > 4 || rect.top > 4;

    return large && notLauncher && notFullscreen && highLayer(node) && hasRichpanelSignal(node);
  }

  function nodes() {
    if (!document.body) return [];
    return Array.prototype.slice.call(document.body.querySelectorAll([
      'iframe',
      '[id*=\"rich\" i]', '[class*=\"rich\" i]',
      '[id*=\"panel\" i]', '[class*=\"panel\" i]',
      '[id*=\"rp\" i]', '[class*=\"rp\" i]',
      '[id*=\"chat\" i]', '[class*=\"chat\" i]',
      '[id*=\"support\" i]', '[class*=\"support\" i]',
      '[id*=\"messenger\" i]', '[class*=\"messenger\" i]',
      '[id*=\"launcher\" i]', '[class*=\"launcher\" i]'
    ].join(','))).filter(function (node) {
      return node !== document.body && node !== document.documentElement;
    });
  }

  function clear(node) {
    if (!node || !node.removeAttribute) return;
    node.removeAttribute(LAUNCHER_ATTR);
    node.removeAttribute(WINDOW_ATTR);
  }

  function apply() {
    ensureStyle();

    nodes().forEach(function (node) {
      if (!isMobile()) {
        clear(node);
        return;
      }

      if (isChatWindow(node)) {
        node.setAttribute(WINDOW_ATTR, 'true');
        node.removeAttribute(LAUNCHER_ATTR);
        return;
      }

      if (isLauncher(node)) {
        node.setAttribute(LAUNCHER_ATTR, 'true');
        node.removeAttribute(WINDOW_ATTR);
        return;
      }

      if (node.getAttribute && (node.getAttribute(LAUNCHER_ATTR) || node.getAttribute(WINDOW_ATTR))) {
        clear(node);
      }
    });
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () {
      pending = false;
      apply();
    });
  }

  function runSeries() {
    schedule();
    [100, 300, 700, 1500, 3000, 5000].forEach(function (delay) {
      window.setTimeout(schedule, delay);
    });
  }

  window.addEventListener('resize', runSeries, { passive: true });
  window.addEventListener('orientationchange', runSeries, { passive: true });
  window.addEventListener('pageshow', runSeries, { passive: true });
  window.addEventListener('load', runSeries, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runSeries, { once: true });
  } else {
    runSeries();
  }

  function observe() {
    if (!document.body || !window.MutationObserver) return;
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'id', 'src', 'title', 'aria-label']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe, { once: true });
  } else {
    observe();
  }
})();
